var map = {
	"./icon1.svg": 4703,
	"./icon10.svg": 9652,
	"./icon11.svg": 6799,
	"./icon12.svg": 3837,
	"./icon13.svg": 8666,
	"./icon14.svg": 604,
	"./icon15.svg": 3932,
	"./icon16.svg": 7350,
	"./icon17.svg": 4968,
	"./icon18.svg": 3362,
	"./icon19.svg": 1622,
	"./icon2.svg": 2292,
	"./icon20.svg": 6016,
	"./icon21.svg": 1655,
	"./icon22.svg": 9413,
	"./icon23.svg": 6140,
	"./icon24.svg": 1294,
	"./icon3.svg": 5958,
	"./icon4.svg": 1837,
	"./icon5.svg": 5026,
	"./icon6.svg": 8330,
	"./icon7.svg": 185,
	"./icon8.svg": 4348,
	"./icon9.svg": 3132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4399;